import { ClipboardCheck } from "lucide-react";
import { useTranslation } from "react-i18next";
import { SunProtectionHeader } from "@/components/organisms/SunProtectionHeader/SunProtectionHeader";

type MeasurementDonePageProps = {
    email?: string | null;
    phoneNumber?: string | null;
};

/**
 * Terminal "Inmeting afgerond" page shown to a customer who reopens the
 * zonwering link after the measurement form has been signed. The flow is
 * blocked — the page offers no navigation back into it, only a clickable
 * contact email and phone number.
 */
export function MeasurementDonePage({
    email,
    phoneNumber,
}: MeasurementDonePageProps) {
    const { t } = useTranslation();
    const telHref = phoneNumber
        ? `tel:${phoneNumber.replace(/[^\d+]/g, "")}`
        : "";

    return (
        <div className="min-h-screen bg-gray-50">
            <SunProtectionHeader />
            <main className="mx-auto max-w-lg px-4 py-12">
                <div className="rounded-2xl bg-white px-10 py-12 text-center shadow-sm">
                    <div className="mx-auto mb-6 flex size-16 items-center justify-center rounded-full bg-primary/15">
                        <ClipboardCheck className="size-8 text-primary" />
                    </div>
                    <h1
                        data-testid="measurement-done-heading"
                        className="mb-3 text-2xl font-bold text-gray-900"
                    >
                        {t("measurementDonePage.title")}
                    </h1>
                    <p className="mx-auto mb-4 max-w-sm text-sm text-gray-500">
                        {t("measurementDonePage.body")}
                    </p>
                    {(email || phoneNumber) && (
                        <p className="mx-auto max-w-sm text-sm text-gray-500">
                            {t("measurementDonePage.contactPrefix")}{" "}
                            {email && (
                                <a
                                    data-testid="measurement-done-email"
                                    href={`mailto:${email}`}
                                    className="font-semibold text-primary underline hover:text-primary-dark"
                                >
                                    {email}
                                </a>
                            )}
                            {email && phoneNumber && (
                                <>
                                    {" "}
                                    {t(
                                        "measurementDonePage.contactSeparator",
                                    )}{" "}
                                </>
                            )}
                            {phoneNumber && (
                                <a
                                    data-testid="measurement-done-phone"
                                    href={telHref}
                                    className="font-semibold text-primary underline hover:text-primary-dark"
                                >
                                    {phoneNumber}
                                </a>
                            )}
                        </p>
                    )}
                </div>
            </main>
        </div>
    );
}
